import React from 'react';
import CardHeader from "components/CardHeader";
import {ImageFile} from "types/MediaFile";
import Dot from "components/Dot";
import Spinner from "../Spinner";

export type Colour = "brand" | "blue" | "green" | "yellow" | "red" | "gray"

type Props = {
  heading?: string
  subheading?: string | null
  action?: React.ReactNode
  banner?: ImageFile | null
  pingColour?: Colour | null | false
  dotColour?: Colour | null | false
  isLoading?: boolean
  children: React.ReactNode
}

function Card({action, banner, children, dotColour, heading, isLoading, pingColour, subheading}: Props) {
  return (
    <div className="relative bg-white shadow sm:rounded-lg flex flex-col">
      {banner && (
        <img
          src={banner.original_url}
          alt={heading ?? banner.name}
          className="max-h-36 w-full object-cover sm:rounded-t-lg"
        />
      )}

      {heading && <CardHeader title={heading} subtitle={subheading} action={action}/>}

      <div className="px-4 py-5 sm:p-6 flex flex-col flex-grow">
        {children}
      </div>

      {(pingColour || dotColour) &&
        <div className="absolute top-0 right-0 -mt-1 -mr-1 ">
          <Dot colour={pingColour || dotColour || "brand"} ping={!!pingColour}/>
        </div>
      }

      {isLoading &&
        <div className="absolute top-0 right-0 mt-2 mr-2 ">
          <Spinner color={Spinner.colors.BRAND} size={Spinner.sizes.X_SMALL}/>
        </div>
      }
    </div>
  );
}

export default Card;